import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';


import AppProviders from './AppProviders'
import CartState from "./Context/Cart/CartState";
import TableSessionState from "./Context/TableSession/TableSessionState";
import { initSentry } from './services/sentry';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProviders>
      <CartState>
        <TableSessionState>
          <App />
        </TableSessionState>
      </CartState>
    </AppProviders>
  </React.StrictMode>
);

